// @flow
import { colorContentDim } from '@duxton-web/design-tokens/themes/light';
import { Card, Flex, Typography } from '@duxton-web/ui';
import React, { useMemo } from 'react';

import { SMART_CAMPAIGN_INBOX_CATEGORIES } from 'omega-rtc/constants/ucd';

const PCIDescriptor = ({ title, value }) => {
  return (
    <Flex vertical gap={8}>
      <Typography.Body level={3} style={{ color: colorContentDim }}>
        {title}
      </Typography.Body>
      <Typography.Body level={2} style={{ textShadow: 'none' }}>
        {value || '-'}
      </Typography.Body>
    </Flex>
  );
};

const SmartCampaignPCIPreview = ({ pciMetaData }) => {
  const inboxCategoryDisplayName = useMemo(() => {
    const chosenCategory = SMART_CAMPAIGN_INBOX_CATEGORIES.find(
      (CATEGORY) => CATEGORY.value === pciMetaData.category,
    );

    return (chosenCategory && chosenCategory.label) || '';
  }, [pciMetaData.category]);
  return (
    <div style={{ whiteSpace: 'pre-wrap' }}>
      <Typography.Body level={2} strong>
        Inbox message
      </Typography.Body>
      <Card
        styles={{
          body: { padding: 16 },
        }}
        style={{ marginTop: 8 }}
        // TODO: to enable when edit feature is required
        // actions={[
        //   <div style={{ display: 'flex', paddingLeft: 16 }}>
        //     <Button
        //       type="secondary"
        //       icon={<EditOutlined />}
        //       style={{ color: colorBrandSecondaryBoldest }}
        //     >
        //       <Typography.Body
        //         style={{ color: colorBrandSecondaryBoldest }}
        //         level={3}
        //       >
        //         Edit
        //       </Typography.Body>
        //     </Button>
        //   </div>,
        // ]}
      >
        <Flex vertical gap={12}>
          <PCIDescriptor title={'Category'} value={inboxCategoryDisplayName} />
          <PCIDescriptor title={'Title'} value={pciMetaData.title} />
          {pciMetaData.subtitle && (
            <PCIDescriptor title={'Subtitle'} value={pciMetaData.subtitle} />
          )}
          <PCIDescriptor
            title={'Cover image'}
            value={pciMetaData.coverImageURL}
          />

          <Flex vertical gap={8}>
            <Typography.Body level={3} style={{ color: colorContentDim }}>
              Message (HTML Support)
            </Typography.Body>
            <Typography.Body level={2} style={{ textShadow: 'none' }}>
              <div
                style={{
                  flexWrap: 'wrap',
                  wordBreak: 'break-word',
                }}
                dangerouslySetInnerHTML={{
                  __html: pciMetaData.message || '-',
                }}
              />
            </Typography.Body>
          </Flex>
          <PCIDescriptor title={'Button text'} value={pciMetaData.buttonText} />
          <PCIDescriptor title={'Button link'} value={pciMetaData.buttonLink} />
        </Flex>
      </Card>
    </div>
  );
};
export default SmartCampaignPCIPreview;
